import axios from "axios";

const BASE_URL = "https://myshopbackend-production.up.railway.app";

export const publicRequest = axios.create({
  baseURL: BASE_URL,
});
